// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalBottom_backdrop__y9dJT","modal":"ModalBottom_modal__qDtta","slide-down":"ModalBottom_slide-down__SQN8-"};